'use strict';

export default function becomeGuide($q, $state, userModel, analytics, join) {
  'ngInject';

  return (() => {
    let joinPromise;

    if (!userModel.item.id) {
      joinPromise = join.showModal('guide').result;
    }

    return $q.resolve(joinPromise)
      .then(() => {
        if (!userModel.item.id) {
          return;
        } else {
          // Redirect user to settings page only if he is logging in
          // Otherwise the user just registered and need to confirm email...
          // https://app.getsentry.com/showaround/fe-production/issues/113600912/
          $state.go('settings');
        }
      });
  });
}



// WEBPACK FOOTER //
// ./app/src/services/become_guide.js